import actions from "@/store/modules/data/actions";
import mutations from "@/store/modules/data/mutations";
import dataGetters from "@/store/modules/data/getters";

const state = {
  isFetchingData: false,
  bookingTemplates: [],
  currentBookingTemplate: {},
  locations: [],
  reasonsForHire: [],
  costCodes: [],
  countries: [],
  isFetchingFieldNecessities: false,
  fieldNecessities: [],
  publishingScheduleTags: [],
  isFetchingPublishingScheduleTags: false,
  costCategories: [],
  isFetchingCostCategories: false,
  sexualOrientations: [],
  isFetchingSexualOrientations: false,
  religions: [],
  isFetchingReligions: false,
  isFetchingMaritalStatuses: false,
  maritalStatuses: [],
  locationGroupings: [],
  ethnicGroups: [],
  isFetchingGrades: false,
  grades: [],
  isFetchingWorkingHours: false,
  workingHours: [],
  isFetchingFunctions: false,
  functions: [],
  isFetchingContractTypes: false,
  contractTypes: [],
  isFetchingTags: false,
  tags: [],
  isFetchingWorkingHoursGroupings: false,
  workingHoursGroupings: [],
  isFetchingContractTypesGroupings: false,
  contractTypesGroupings: []
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters: dataGetters
};
